import { SVGAttributes } from "react"

interface SvgProps extends SVGAttributes<SVGSVGElement> { }

namespace MessageIcons {
    export const SvgCheck = (props: SvgProps) => {
        return (
            <svg
                width="800px"
                height="800px"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                fill="#000000"
                {...props}
            >
                <g strokeWidth="0">
                </g>
                <g strokeLinecap="round" strokeLinejoin="round">
                </g>
                <g>
                    <path
                        d="M512 512m-448 0a448 448 0 1 0 896 0 448 448 0 1 0-896 0Z"
                        fill="#6fd867"
                    />
                    <path
                        d="M738.133333 311.466667L448 601.6l-119.466667-119.466667-59.733333 59.733334 179.2 179.2 349.866667-349.866667z"
                        fill="#ffffff"
                    />
                </g>
            </svg>
        )
    }

    export const SvgDanger = (props: SvgProps) => {
        return (
            <svg
                width="800px"
                height="800px"
                viewBox="0 0 1024 1024"
                className="icon"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                fill="#000000"
                {...props}
            >
                <g strokeWidth="0" />
                <g strokeLinecap="round" strokeLinejoin="round" />
                <g>
                    <path
                        d="M452.266667 955.733333l-384-384c-34.133333-34.133333-34.133333-87.466667 0-121.6l384-384c34.133333-34.133333 87.466667-34.133333 121.6 0l384 384c34.133333 34.133333 34.133333 87.466667 0 121.6l-384 384c-34.133333 34.133333-89.6 34.133333-121.6 0z"
                        fill="#b05151"
                    />
                    <path
                        d="M460.8 697.6c0-6.4 2.133333-12.8 4.266667-19.2 2.133333-6.4 6.4-10.666667 10.666666-14.933333 4.266667-4.266667 10.666667-8.533333 17.066667-10.666667s12.8-4.266667 21.333333-4.266667 14.933333 2.133333 21.333334 4.266667c6.4 2.133333 12.8 6.4 17.066666 10.666667 4.266667 4.266667 8.533333 8.533333 10.666667 14.933333 2.133333 6.4 4.266667 12.8 4.266667 19.2s-2.133333 12.8-4.266667 19.2-6.4 10.666667-10.666667 14.933333c-4.266667 4.266667-10.666667 8.533333-17.066666 10.666667-6.4 2.133333-12.8 4.266667-21.333334 4.266667s-14.933333-2.133333-21.333333-4.266667-10.666667-6.4-17.066667-10.666667c-4.266667-4.266667-8.533333-8.533333-10.666666-14.933333s-4.266667-10.666667-4.266667-19.2z m89.6-98.133333h-76.8L462.933333 277.333333h98.133334l-10.666667 322.133334z"
                        fill="#FFFFFF"
                    />
                </g>
            </svg>
        )
    }

    export const SvgWarning = (props: SvgProps) => {
        return (
            <svg
                width="800px"
                height="800px"
                viewBox="0 0 1024 1024"
                className="icon"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                fill="#000000"
            >
                <g strokeWidth="0">
                </g>
                <g strokeLinecap="round" strokeLinejoin="round">
                </g>
                <g>
                    <path
                        d="M452.266667 955.733333l-384-384c-34.133333-34.133333-34.133333-87.466667 0-121.6l384-384c34.133333-34.133333 87.466667-34.133333 121.6 0l384 384c34.133333 34.133333 34.133333 87.466667 0 121.6l-384 384c-34.133333 34.133333-89.6 34.133333-121.6 0z"
                        fill="#dada00"
                    />
                    <path
                        d="M460.8 697.6c0-6.4 2.133333-12.8 4.266667-19.2 2.133333-6.4 6.4-10.666667 10.666666-14.933333 4.266667-4.266667 10.666667-8.533333 17.066667-10.666667s12.8-4.266667 21.333333-4.266667 14.933333 2.133333 21.333334 4.266667c6.4 2.133333 12.8 6.4 17.066666 10.666667 4.266667 4.266667 8.533333 8.533333 10.666667 14.933333 2.133333 6.4 4.266667 12.8 4.266667 19.2s-2.133333 12.8-4.266667 19.2-6.4 10.666667-10.666667 14.933333c-4.266667 4.266667-10.666667 8.533333-17.066666 10.666667-6.4 2.133333-12.8 4.266667-21.333334 4.266667s-14.933333-2.133333-21.333333-4.266667-10.666667-6.4-17.066667-10.666667c-4.266667-4.266667-8.533333-8.533333-10.666666-14.933333s-4.266667-10.666667-4.266667-19.2z m89.6-98.133333h-76.8L462.933333 277.333333h98.133334l-10.666667 322.133334z"
                        fill="#FFFFFF"
                    />
                </g>
            </svg>
        )
    }


    export const SvgInfo = (props: SvgProps) => {
        return (
            <svg
                width="800px"
                height="800px"
                viewBox="0 0 1024 1024"
                className="icon"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                fill="#000000"
                stroke="#000000"
                {...props}
            >
                <g strokeWidth="0" />
                <g strokeLinecap="round" strokeLinejoin="round" />
                <g>
                    <path
                        d="M512 512m-448 0a448 448 0 1 0 896 0 448 448 0 1 0-896 0Z"
                        fill="#525252"
                    />
                    <path d="M469.333333 469.333333h85.333334v234.666667h-85.333334z" fill="#FFFFFF" />
                    <path
                        d="M512 352m-53.333333 0a53.333333 53.333333 0 1 0 106.666666 0 53.333333 53.333333 0 1 0-106.666666 0Z"
                        fill="#FFFFFF"
                    />
                </g>
            </svg>
        )
    }

    export const SvgClose = (props: SvgProps) => {
        return (
            <svg {...props} width="800px" height="800px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 5L5 19M5.00001 5L19 19" stroke="#000000" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    }
}

export default MessageIcons